<template>
  <div class="container-wrapper">
    <div class="bottom-container">
      <a href="/RegulamentoFifaChallenge2023.pdf" class="regulamento-link" target="_blank">
      <p class="text" style="font-size: 14px">Bases Legales</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .container-wrapper{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .como-llegar{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;  
      .heading-wrapper{
        margin-bottom: 44px;
        .heading{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 700;
          font-size: 36px;
          line-height: 43px;
          text-align: center;
          color: #012A2D;
        }
        svg{
          width: 215px;
        }
      }
      .empty-container{
        width: 1200px;
        height: 332px;
        background: #D9D9D9;
        margin-bottom: 50px;
        position: relative;
        z-index: 2;
        @media only screen and (max-width:1260px){
          width: 100%;
        }
      }
    }
    .bg-zigzag{
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .bottom-container{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 104px;
      background: #012A2D;
      position: relative;
      z-index: 2;
      &>*:not(:last-child){
        margin-right: 80px;
        @media only screen and (max-width:780px){
          margin-right: 40px;
        }
      }
      .text{
        font-family: 'Lato';
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        color: #FFFFFF;
        @media only screen and (max-width:780px){
          font-size: 24px;
        }
      }
    }
    .regulamento-link{
      text-decoration: none;
    }
  }

</style>